<template>
    <ModalBox
        class="competition-modal"
        :is-active.sync="isActive">
        <div class="is-relative">
            <img
                alt="Banner"
                src="@/assets/Competition/Raffle/modal/banner.png">

            <CompetitionMain modal></CompetitionMain>
        </div>

        <h3 class="competition-modal_title">
            {{ $t("webmaster.dashboard.competition.modal.title") }}
        </h3>

        <div class="competition-modal_wrapper-paragraph">
            <div class="competition-modal_paragraph">
                <div class="competition-modal_paragraph__wrapper-img">
                    <img
                        alt="line"
                        class="competition-modal_paragraph-img"
                        src="@/assets/Competition/Raffle/modal/paragraph-1.svg">
                    <div class="competition-modal_paragraph-line">
                    </div>
                </div>
                <p class="competition-modal_paragraph-text">
                    {{ $t("webmaster.dashboard.competition.modal.conditions.1") }}
                </p>
            </div>
            <div class="competition-modal_paragraph">
                <div class="competition-modal_paragraph__wrapper-img">
                    <img
                        alt="line"
                        class="competition-modal_paragraph-img"
                        src="@/assets/Competition/Raffle/modal/paragraph-2.svg">
                    <div class="competition-modal_paragraph-line">
                    </div>
                </div>
                <p class="competition-modal_paragraph-text">
                    {{ $t("webmaster.dashboard.competition.modal.conditions.2") }}
                </p>
            </div>
            <div class="competition-modal_paragraph">
                <div class="competition-modal_paragraph__wrapper-img">
                    <img
                        alt="line"
                        class="competition-modal_paragraph-img"
                        src="@/assets/Competition/Raffle/modal/paragraph-3.svg">
                    <div class="competition-modal_paragraph-line">
                    </div>
                </div>
                <p class="competition-modal_paragraph-text">
                    {{ $t("webmaster.dashboard.competition.modal.conditions.3") }}
                </p>
            </div>
        </div>

        <i18n
            class="competition-modal_prize-fund"
            path="webmaster.dashboard.competition.modal.prizeFund">
            <template #money>
                <span class="has-text-white">$10,000</span>
            </template>
        </i18n>

        <div class="wrapper-present">
            <CompetitionPresentItem
                :key="present"
                v-for="present in [1, 2, 3]"
                :place="present"
                :class="`_present-${ present }`">
            </CompetitionPresentItem>
        </div>

        <div class="competition-modal_prank">
            <img
                alt="suitcase"
                class="competition-modal_prank-img"
                src="@/assets/Competition/Raffle/modal/suitcase.svg">
            <div class="is-align-content-center">
                <p class="competition-modal_prank-text">
                    {{ $t("webmaster.dashboard.competition.modal.prized.bonus.title") }}
                </p>
                <p class="competition-modal_prank-text has-text-white">
                    {{ $t("webmaster.dashboard.competition.modal.prized.bonus.text") }}
                </p>
            </div>
        </div>
        <div class="competition-modal_prank mt-4">
            <img
                alt="hand"
                class="competition-modal_prank-img"
                src="@/assets/Competition/Raffle/modal/hand.svg">
            <div class="is-align-content-center">
                <p class="competition-modal_prank-text">
                    {{ $t("webmaster.dashboard.competition.modal.prized.conditions.title") }}
                </p>
                <p class="competition-modal_prank-text has-text-white">
                    {{ $t("webmaster.dashboard.competition.modal.prized.conditions.text") }}
                </p>
            </div>
        </div>

        <p class="competition-modal_footer-text">
            {{ $t("webmaster.dashboard.competition.modal.footer.text") }}
        </p>

        <div
            class="competition-modal_footer-button"
            @click="openOffers">
            <InlineSvg
                class="competition-modal_footer-button__img"
                alt="button"
                :src="img()">
            </InlineSvg>
            <p>
                {{ $t("webmaster.dashboard.competition.modal.footer.button") }}
            </p>
        </div>
    </ModalBox>
</template>

<script>
  import CompetitionMain from "@/components/Common/Competition/CompetitionMain.vue";
  import ModalBox from "@/components/Common/Modals/ModalBox.vue";
  import { mapFields } from "@vasiliyrusin/vue-mapfields";
  import { UPDATE_OPTIONS } from "@core/store/action-constants";
  import CompetitionPresentItem from "@/components/Common/Competition/CompetitionPresentItem.vue";
  import { encodeFilters } from "@core/filters";
  import InlineSvg from "vue-inline-svg";

  export default {
    name: "CompetitionModal",

    components: {
      InlineSvg,
      CompetitionPresentItem,
      CompetitionMain,
      ModalBox
    },

    computed: {
      ...mapFields("competition", {
        fields: ["isActive"],
        base: "options",
        action: UPDATE_OPTIONS
      })
    },

    methods: {
      img () {
        return require("@/assets/Competition/Raffle/modal/button.svg");
      },

      openOffers () {
        this.isActive = false;
        this.$router.push({
          name: "webmaster:offers",
          query: {
            backLink: this.$route.fullPath,
            filters: encodeFilters({ inCompetition: true })
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
@import "~@/scss/competition-banner";

::v-deep {
  .modal-card {
    width: 100%;
    max-width: 670px !important;

    font-family: "CompetitionFont";
    color: white;

    .modal-card-body {
      padding: 32px;
      background-color: black;
    }

    .modal-card-foot,
    .modal-card-head {
      display: none;
    }
  }

  .present_text {
    font-size: 26px !important;
  }

  .competition-main {
    top: 63%;
  }

  .present_img {
    width: 127px;
    height: 44px;
  }
}

.wrapper-present {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  gap: 30px;
  margin-top: 25px;
}

.present {
  width: 130px !important;
}

.competition-modal_prank {
  display: flex;
  gap: 26px;
  margin-top: 24px;
}

.competition-modal_prank-img {
  width: 140px;
  height: 100px;
}

.competition-modal_prank-text {
  font-family: "Rubik";
  font-weight: 400;
  font-size: 14px;
  line-height: 129%;
  color: $light-gray_;
}

.competition-modal_footer-text {
  font-family: "Rubik";
  font-weight: 400;
  font-size: 14px;
  line-height: 129%;
  text-align: center;
  color: $light-gray_;

  margin-top: 32px;
  margin-bottom: 20px;
}

.competition-modal_footer-button {
  position: relative;
  margin: 0 auto;
  width: fit-content;
  max-width: 100%;
  cursor: pointer;

  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: -0.03em;

  &:hover &__img {
    color: $main-color;
  }

  &__img {
    width: 302px;
    max-width: 100%;
    height: 48px;
    color: $hover-red-color;
    transition: color 0.15s ease-in-out;
  }

  & p {
    font-family: "Rubik";
    position: absolute;
    @extend %centerStyle;
  }
}



.competition-modal_title {
  font-family: "Rubik";
  font-weight: 500;
  font-size: clamp(0.875rem, 0.4583rem + 2.0833vw, 1.5rem);
  line-height: 125%;
  margin-top: 20px;
}

.competition-modal_paragraph__wrapper-img {
  display: flex;
  flex-direction: column;

  position: absolute;
  top: 0;
}

.competition-modal_wrapper-paragraph {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: 32px;
}

.competition-modal_paragraph {
  position: relative;
  width: 182px;
  padding-top: 50px;

  &:first-child {
    .competition-modal_paragraph-text {
      margin-left: 20px;
    }

    .competition-modal_paragraph-line {
      background: url("~@/assets/Competition/Raffle/modal/paragraph-line-1.svg");
    }
  }

  &:nth-child(2) {
    .competition-modal_paragraph-text {
      margin-left: 10px;
    }
    .competition-modal_paragraph-line {
      height: 5px;
      background: url("~@/assets/Competition/Raffle/modal/paragraph-line-2.svg");
      background-size: contain;
    }
  }

  &:nth-child(3) {
    .competition-modal_paragraph-line {
      background: url("~@/assets/Competition/Raffle/modal/paragraph-line-3.svg");
    }
  }
}

.competition-modal_paragraph-text {
  font-family: "Rubik";
  font-weight: 400;
  font-size: 14px;
  line-height: 129%;
}

.competition-modal_paragraph-img {
  height: 22px;
  margin-bottom: 18px;
}

.competition-modal_paragraph-line {
  width: 171px;
  height: 23px;
}

.competition-modal_wrapper-paragraph {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.competition-modal_prize-fund {
  display: block;
  margin-top: 48px;

  font-family: "Rubik";
  font-weight: 500;
  font-size: clamp(1.125rem, 0.875rem + 1.25vw, 1.5rem);
  line-height: 125%;
  color: $light-gray_;
  text-align: center;
}

@media screen and (max-width: 550px) {
  ::v-deep {
    .logo.modal-size {
      height: 80px !important;
    }

    .competition-main {
      top: 45%;
    }

    .competition-modal_prank-img {
      display: none;
    }
  }
}

@media screen and (max-width: 730px) {
  .competition-modal_paragraph-line {
    background: url("~@/assets/Competition/Raffle/modal/paragraph-line-2.svg") !important;
    background-size: contain !important;
    width: 173px;
    height: 5px;
  }

  .wrapper-present {
    gap: 15px;
  }
}
</style>
